import { render, staticRenderFns } from "./MasterDrawer.vue?vue&type=template&id=16b6c9e8"
import script from "./MasterDrawer.vue?vue&type=script&lang=js"
export * from "./MasterDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports